import { Link } from 'react-router-dom';
import { FeatureFlagName, useHasFeatureFlag } from 'hooks/users';
import Tab from 'components/common/Tab';

interface ExportPageNavigationProps {
  surveyId: number;
  currentPage: 'crosstab' | 'charts' | 'ai-coding';
}

const ExportPageNavigation = ({
  surveyId,
  currentPage,
}: ExportPageNavigationProps) => {
  const hasAICodingAccess = useHasFeatureFlag(FeatureFlagName.FF_GLA_2523);

  return (
    <div className="flex items-end space-x-4 text-sm mt-6 mb-4 border-b border-light-grey">
      <Link to={`/surveys/${surveyId}/analyze/export/crosstab`}>
        <Tab isActive={currentPage === 'crosstab'}>
          <span>Crosstab</span>
        </Tab>
      </Link>

      <Link to={`/surveys/${surveyId}/analyze/export/charts`}>
        <Tab isActive={currentPage === 'charts'}>
          <span>Charts</span>
        </Tab>
      </Link>

      {hasAICodingAccess && (
        <Link to={`/surveys/${surveyId}/analyze/export/ai-coding`}>
          <Tab isActive={currentPage === 'ai-coding'}>
            <span>AI Coding</span>
          </Tab>
        </Link>
      )}
    </div>
  );
};

export default ExportPageNavigation;
